window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.HoffmanLifeSlider = (function HoffmanLifeSlider() {
  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $slider = document.querySelector('.hoffman-life-lp .hoffman-life-slider .slider-items');

    if ($slider) {
      new Flickity($slider, {
        // options
        cellAlign: 'left',
        imagesLoaded: true,
        lazyLoad: true,
        prevNextButtons: false,
        pageDots: true,
        selectedAttraction: 0.01,
        friction: 0.2
        // autoPlay: 3500
      } );
    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
